/**
 * Datos del reconocimiento LAS 100 PRO 2026 que **no son texto**: la ruta del
 * distintivo y la fecha de la ceremonia.
 *
 * Aquí vivía también `registro`, la liga al formulario. Alan la quitó el
 * 2026-09-21.
 *
 * Viven fuera del diccionario por el mismo motivo que los precios del sitio:
 * una fecha o una URL que pudiera divergir entre idiomas es un defecto
 * esperando a pasar, y quien traduce no tiene por qué volver a teclear una liga.
 *
 * En su propio módulo y no dentro de `AnuncioPro.tsx` porque un archivo que
 * exporta componentes y constantes a la vez rompe Fast Refresh — el mismo
 * criterio que `components/ui/Button/buttonStyles.ts`. El nombre no es
 * `anuncioPro.ts` porque en Windows chocaría con `AnuncioPro.tsx`: el sistema de
 * archivos no distingue mayúsculas y TypeScript resuelve el import al primero.
 */
export const anuncioPro = {
  logo: '/recursos/las100pro-2026.png',
  /**
   * Ceremonia de premiación, en hora local de quien mira.
   *
   * La `T00:00:00` no sobra: `new Date('2026-11-19')` se interpreta como
   * medianoche **UTC**, y en México eso cae el día 18 por la tarde. La fecha se
   * imprimiría con un día de menos justo en el dato que la gente usa para
   * apuntarse a algo.
   */
  fechaCeremonia: '2026-11-19T00:00:00',
} as const;

/**
 * ¿La ceremonia todavía no ocurre?
 *
 * De esto depende que se enseñe el dato de la premiación o sólo el
 * reconocimiento. Anunciar una fecha ya pasada es la clase de detalle que
 * envejece solo en un footer que nadie vuelve a revisar.
 *
 * El corte es el final del día de la ceremonia, no su medianoche inicial: la
 * premiación es por la tarde y durante ese día la invitación sigue valiendo.
 */
export function ceremoniaPendiente(ahora: Date = new Date()): boolean {
  const fin = new Date(anuncioPro.fechaCeremonia);
  fin.setHours(23, 59, 59, 999);
  return ahora.getTime() <= fin.getTime();
}
